import { getFileUploadUrl } from '@modusign/openapi-client-external-document';
import axios from 'axios';

import getExtensionFromFile from '@app/libs/file/getExtensionFromFile';
import workspaceService from '@app/libs/workspaceService';

export default async function uploadFile(
  file: File,
  type: 'ATTACHMENT' | 'DOCUMENT' | 'BATCH_EXCEL'
): Promise<string> {
  const extension = getExtensionFromFile(file);
  if (!extension) {
    throw new Error('확장자 없는 파일은 업로드 할 수 없습니다.');
  }
  const presignedPostUrl = await getFileUploadUrl(workspaceService.getWorkspaceId(), {
    type,
    extension,
  });

  const formData = new FormData();
  Object.entries(presignedPostUrl.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });
  formData.append('file', file);

  await axios.post(presignedPostUrl.url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return presignedPostUrl.fields.key;
}
